

















import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Nav extends Vue {
  items = [
    { name: 'Home', path: '/', icon: 'home' },
    { name: 'Products', path: '/products', icon: 'store' },
    { name: 'About', path: '/about', icon: 'people' },
  ]

  get currentPath() {
    return this.$route.path
  }
}
